module.exports = __webpack_public_path__ + "img/Res_Mus_ekl.6e4dfc61.jpg";